import {
  ACCEPTED_EXTENSIONS,
  DEFAULT_SATISFACTORY_RATING,
  FEEDBACK_CATEGORY,
} from "./sidebarFeedback.constants";

export type UploadedAttachment = {
  id?: string;
  filename: string;
  screenshotUrl: string;
  isUploading?: boolean;
  fileSize?: string;
};

export type FeedbackPayload = {
  username: string;
  email: string;
  meetingId?: string;
  suggestions: string;
  issuesFaced: string[];
  screenshots: UploadedAttachment[];
  category: string;
  satisfactoryRating: number;
};

type AuthUser = {
  user?: {
    display_name?: string;
    user_email?: string;
  };
};

export function getFileExtension(fileName: string): string {
  const parts = fileName.split(".");
  if (parts.length <= 1) return "";
  return parts[parts.length - 1].toLowerCase();
}

export function isSupportedAttachment(file: File): boolean {
  const extension = getFileExtension(file.name);
  return ACCEPTED_EXTENSIONS.includes(extension);
}

type SizeKey = "Bytes" | "KB" | "MB" | "GB";

export function formatFileSize(bytes: number, t: (key: SizeKey) => string): string {
  if (bytes < 1024) return `${bytes} ${t("Bytes")}`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} ${t("KB")}`;
  const mb = kb / 1024;
  if (mb < 1024) return `${mb.toFixed(1)} ${t("MB")}`;
  const gb = mb / 1024;
  return `${gb.toFixed(2)} ${t("GB")}`;
}

export function createFeedbackPayload(
  authUser: AuthUser | null | undefined,
  feedbackType: string,
  feedbackText: string,
  attachments: UploadedAttachment[]
): FeedbackPayload {
  return {
    username: authUser?.user?.display_name ?? "",
    email: authUser?.user?.user_email ?? "",
    meetingId: '',
    suggestions: feedbackText.trim(),
    issuesFaced: [feedbackType],
    // Send only finalized uploads and only required fields.
    screenshots: attachments
      .filter((item) => Boolean(item.screenshotUrl))
      .map((item) => ({
        filename: item.filename,
        screenshotUrl: item.screenshotUrl,
      })),
    category: FEEDBACK_CATEGORY,
    satisfactoryRating: DEFAULT_SATISFACTORY_RATING,
  };
}
